<template>
    <PlainPage>
        <img v-if="isMarketingTemplate" class="image_register" :src="configTni.marketingtemplate_renewal_register_image_url" alt="" />
        <img v-else class="image_register" :src="configTni.consent_standard_register_image_url" alt="" />

        <div class=" pl-9 pr-9 pt-10">
            <FormRegister ref="form-register" v-model="formValid"></FormRegister>

            <div class="mt-6 text-center">
                <MainButton @click="clickSubmit()" class="btn_submit text-18" color="orange-2" :disabled="!formValid">
                    ยืนยัน
                </MainButton>
            </div>
        </div>

        <div class="pt-20 pl-9 pr-9 pb-5">
            <div class="text-a-gray-707070 text-12 font-bold pb-1">หมายเหตุ :</div>
            <div class="leading-normal text-a-gray-707070 text-11">
                การลงทะเบียนจำเป็นต้องใช้เลขบัตรประชาชน สำหรับยืนยันตัวตน
                และตรวจสอบข้อมูลความถูกต้องของลูกค้า เพื่อความสะดวกรวดเร็ว
                ในการรับบริการ เช่น แจ้งอุบัติเหตุผ่านไลน์ โดยไม่ต้องใช้เลขกรมธรรม์
                หรือตรวจสอบข้อมูลกรมธรรม์ง่ายๆ ด้วยตนเองตลอด 24 ชม.
            </div>
        </div>
    </PlainPage>
</template>
<script>

import Account from "@/helper/AccountHelper.js";
import CacheHelper from '@/helper/CacheHelper';
//component
import PlainPage from '@/components/Layout/Page/PlainPage.vue';
import FormRegister from '../component/FormRegister/FormRegister.vue';
import MainButton from '@/components/Button/MainButton.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
//service
import ConsentApi from '../../ConsentRegister/service/ConsentApi';
import StandardRegisterApi from '../service/StandardRegisterApi';
import { useTracking } from "@/feature/TrackingFeature"

export default {
    name: "StarndardRegisterFormPage",
    mixins: [ModalMixin],
    components: {
        FormRegister,
        MainButton,
        PlainPage
    },data: function() {
        return {
            configTni: {},
            formValid: false,
            userCookie: {},
            isMarketingTemplate: false,
        }
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    created: function() {
        this.getBlobConfig();
        this.userCookie = Account.getCacheUser();
        if (this.$route.query.type && this.$route.query.type.toLowerCase().indexOf('marketing') > -1) {
            this.isMarketingTemplate = true
        }
    },
    methods: {
        getBlobConfig: function() {
            ConsentApi.apiGetTniConfig().subscribe({
                next: (data) => {
                    this.configTni = data;
                },
                error: (err) => {
                    this.errorApi(err);
                },
            });
        },
        clickSubmit: async function () {
            this.tracking.event("register_standard_page", "click_confirm_register", "", "");
            let valid = this.$refs['form-register'].validate();
            if (!valid) {
                return;
            }

            let formData = this.$refs['form-register'].getValue();

            // case registered
            if (this.userCookie && this.userCookie.detail && this.userCookie.detail.Line) {
                let display_name = this.userCookie.detail.Line.Line_profile_displayName;
                let user_mid = this.userCookie.detail.Line.Line_userId;
                formData.setDisplayName(display_name);
                formData.setMid(user_mid);
            }
            else {
                // error not register
                let errorUserLoginCookie = Account.getCacheErrorUserLoginCookie();
                if (errorUserLoginCookie && errorUserLoginCookie.line_user_id) {
                    formData.setMid(errorUserLoginCookie.line_user_id);
                }
                if (errorUserLoginCookie && errorUserLoginCookie.line_displayname) {
                    formData.setDisplayName(errorUserLoginCookie.line_displayname);
                }
            }


            if (this.isMarketingTemplate) {
                let query = this.$route.query

                formData.setQuestionnaireId(query.template_no)
                formData.setLinkNo(query.link_no)
                formData.setFlowType(query.type)
                formData.setFromPolicyRenewal(true)
            }

            if (this.isMarketingTemplate) {
                return this.flowRegisterMkt(formData);
            }

            let cache = new CacheHelper('cookie');
            let targetPage = cache.getCache('target_page') ? cache.getCache('target_page') : null
            if (targetPage != null) {
                return this.flowRegisterStdWait(formData, targetPage);
            }

            let params = formData.getParams();
            
            this.modal.loadingModal.show();
            let registerData = await this.apiStandardRegister(params);
            this.modal.loadingModal.hide();
            
            if (registerData != null) {
                this.clearFormCache();
                window.location.replace("/registerstandard/success")
            }
        },
        apiStandardRegister: function (params) {
            return new Promise((resolve) => {
                let token = this.userCookie?.token ?? null;
                StandardRegisterApi.apiStandardRegister(params, token).subscribe({
                    next: (data) => {
                        resolve(data);
                    },
                    error: (err) => {
                        resolve(null);
                        this.errorApi(err);
                        
                    },
                });
            });
        },
        clearFormCache: function () {
            let cache = new CacheHelper('session');
            cache.removeCache('form_standardregister');
        },
        flowRegisterMkt: async function (formData) {
            let params = formData.getParamsFlowType();
            
            this.modal.loadingModal.show();
            let registerData = await this.apiRegisterMKT(params);
            this.modal.loadingModal.hide();

            if (registerData) {
                let queryStr = this.$route.fullPath.split('?')
                window.location.replace("/landing/line?target_page=renewal" + "&" + queryStr[1])
            }
        },
        flowRegisterStdWait: async function(formData, targetPage) {
            let params = formData.getParamsFlowType()

            this.modal.loadingModal.show();
            let registerData = await this.apiRegisterMKT(params);
            this.modal.loadingModal.hide();

            if (registerData) {
                window.location.replace("/landing/line?target_page=" + targetPage)
            }
        },
        apiRegisterMKT: function(params) {
            return new Promise((resolve) => {
                let token = this.userCookie?.token ?? null;
                StandardRegisterApi.apiMarketingTemplateRegister(params, token).subscribe({
                    next: (data) => {
                        resolve(data)
                    },
                    error: (err) => {
                        resolve(null);
                        if (err.code == '409') {
                            if (this.isMarketingTemplate) {
                                window.location.replace("/register/error?MarketingTemplate=true")
                            } else {
                                window.location.replace("/register/error?StandardWait=true")
                            }
                        }
                    }
                })
            })
        },
    },
}
</script>
<style lang="scss" scoped>

.btn_submit {
    width: 50%;
}
</style>
